import { useQuery } from '@tanstack/react-query'
import { useAlertService } from '@/shared/lib/useAlertService'
import { CheckinsService } from '@/shared/api/rest/services/checkins.service'
import {
    adaptAggregates,
    emptyAggregate,
    AggregateByAgeGroup
} from '@/shared/api/rest/checkins.adapters'
import convertDateToIsoString from '@/shared/utils/convertDateToIsoString'

export function useAggregate({
    startDate,
    branchId
}: {
    startDate: Date | string
    branchId: string
}) {
    const alertService = useAlertService()
    const isoDate = convertDateToIsoString(startDate)

    const { data, isLoading } = useQuery<AggregateByAgeGroup>({
        queryKey: ['checkin-aggregates', branchId, isoDate],
        queryFn: async () => {
            try {
                const raw = await CheckinsService.aggregates({
                    branch: branchId,
                    checkedInDate: isoDate,
                    checkedOutDate: isoDate
                })
                return adaptAggregates(raw)
            } catch (error) {
                alertService.error(
                    error instanceof Error ? error.message : 'Failed to load aggregates'
                )
                return emptyAggregate()
            }
        }
    })

    return { data: data ?? emptyAggregate(), loading: isLoading }
}
